import { MutationHookOptions, gql, useMutation } from '@apollo/client';

import { GET_BROKERAGE } from './entities.brokerage.details.query';
import { GET_BROKER_DETAILS } from './brokers.details.query';
import { GET_ENTITIES_BROKER_AGENCIES } from './entities.broker.agencies.query';

export const UPSERT_ENTITY_MUTATION = gql`
  mutation upsertEntity($entityInput: EntityInput!) {
    upsertEntity(details: $entityInput) {
      uuid
      referenceId
    }
  }
`;

export function useUpsertBrokerageMutation(options: MutationHookOptions = {}) {
  const [upsertEntity, { loading, error, reset }] = useMutation(
    UPSERT_ENTITY_MUTATION,
    {
      refetchQueries: [
        GET_ENTITIES_BROKER_AGENCIES,
        GET_BROKERAGE,
        GET_BROKER_DETAILS,
      ],
      awaitRefetchQueries: true,
    }
  );

  return {
    upsertEntity,
    loading,
    error,
    reset,
  };
}
